package diana.soleil.design.iraniancanadienbazzar.feature.feed

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

/** Koin bindings for the community feed. Aggregated by the app composition root (`:shared`). */
val feedModule = module {
    viewModel { FeedViewModel(get(), get(), get(), get(), get(), get(), get(), get(), get(), get(), get()) }
    viewModel { parameters -> CommentsViewModel(get(), get(), get(), get(), get(), parameters.get()) }
}
